'use strict';

var jsxRuntime = require('react/jsx-runtime');
var icons_Icon = require('./Icon.js');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

const IconSuccess = icons_Icon.iconFactory('IconSuccess', jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M12,3 C16.9707,3 21,7.0293 21,12 C21,16.9707 16.9707,21 12,21 C7.0293,21 3,16.9707 3,12 C3,7.0293 7.0293,3 12,3 Z M15.7123106,8.65165043 L10.9393398,13.4246212 L8.2876894,10.7729708 L6.69669914,12.363961 L10.9393398,16.6066017 L17.3033009,10.2426407 L15.7123106,8.65165043 Z" }) }));

exports.IconSuccess = IconSuccess;
//# sourceMappingURL=IconSuccess.js.map
